import { useFeatureFlagStructs } from 'util/featureFlags'

export const useFeatureFlagsLoaded = () => {
  const { loadState, structs } = useFeatureFlagStructs()

  // Check for 'loaded' state specifically to avoid false positives during 'reloading'
  // Defensively handle undefined structs (shouldn't happen per types, but safer)
  // Note: Empty structs array (e.g., empty DB in tests) is still considered "loaded"
  return loadState === 'loaded' && structs !== undefined
}
